<template>
    <lottie-player
      ref="lottiePlayer"
      src="Human.json"
      background="transparent"
      speed="1"
      autoplay
      loop
      class="background-lottie"
      :style="lottieStyle"
    ></lottie-player>
    <div ref="container" class="container">
      <div class="svg-container">
        <img src="HWtitle.svg" alt="Background SVG" class="background-svg" />
      </div>
      <div class="bottom-40 ">
        <p>Learn more about the human interaction in Social media</p>
        <button @click="startQuiz" class="start-quiz-button">Discover</button>
    </div>
    </div>
  </template>
  
  <script>
  import '@lottiefiles/lottie-player';
  
  export default {
    data() {
      return {
        lottieStyle: {
          position: 'absolute',
          width: '20%', // Adjust the size of the animation
          height: '20%',
          top: '500px', // Start 500px from the top
          left: '500px', // Start 500px from the left
          opacity: '1', // Transparency
        },
        startTime: null,
        startLeftPosition: 500, // Start 500px from the left
        endLeftPosition: window.innerWidth - 300, // End 300px from the right edge
        startTopPosition: 500, // Start 500px from the top
        endTopPosition: window.innerHeight, // End 300px from the bottom edge
        duration: 30000, // Duration in milliseconds (30 seconds)
      };
    },
    mounted() {
      // Start moving the animation after loading
      this.startTime = Date.now();
      this.updatePosition();
    },
    methods: {
      startQuiz() {
        this.$router.push('/human-wave');
      },
      updatePosition() {
        const currentTime = Date.now();
        const elapsedTime = currentTime - this.startTime;
        const progress = elapsedTime / this.duration;
  
        const currentLeftPosition =
          this.startLeftPosition + (this.endLeftPosition - this.startLeftPosition) * progress;
        const currentTopPosition =
          this.startTopPosition + (this.endTopPosition - this.startTopPosition) * progress;
  
        this.lottieStyle.left = currentLeftPosition + 'px';
        this.lottieStyle.top = currentTopPosition + 'px';
  
        if (progress < 1) {
          requestAnimationFrame(this.updatePosition);
        } else {
          // Loop the animation
          this.startTime = Date.now();
          requestAnimationFrame(this.updatePosition);
        }
      },
    },
  };
  </script>
  
  <style>
  body {
    display: flex;
    flex-direction: column;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    color: white;
    position: relative;
    overflow: hidden;
  }
  .svg-container {
    width: 100%;
  }
  img {
    width: 800px;
  }
  
  .start-quiz-button {
    padding: 10px 20px;
    background-color: transparent;
    border: 2px solid white;
    color: white;
    border-radius: 50px;
    cursor: pointer;
    margin-top: 20px; /* Adds some margin between the button and the text */
  }
  .lottie-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .background-lottie {
    width: 20%;
    height: 20%;
  }
  .bottom-40 {
    position: absolute;
    bottom: 40px;  /* This moves the elements 40 pixels up from the bottom */
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;}


  </style>
  